// Tells pieces placed inside an OP1WebFrameWindow (e.g. OP1WebFrameWindowControl)
// which window they belong to, so a designer can drop them anywhere in the
// header slot without wiring a window id by hand.
import { createContext, useContext } from "react";

const OP1WebFrameWindowContext = createContext({ windowId: null });

export const OP1WebFrameWindowProvider = OP1WebFrameWindowContext.Provider;

export function useFrameWindow() {
  return useContext(OP1WebFrameWindowContext);
}
